"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyTypeItemDto = instanceOfPropertyTypeItemDto;
exports.PropertyTypeItemDtoFromJSON = PropertyTypeItemDtoFromJSON;
exports.PropertyTypeItemDtoFromJSONTyped = PropertyTypeItemDtoFromJSONTyped;
exports.PropertyTypeItemDtoToJSON = PropertyTypeItemDtoToJSON;
exports.PropertyTypeItemDtoToJSONTyped = PropertyTypeItemDtoToJSONTyped;
var PropertyClassDto_1 = require("./PropertyClassDto");
/**
 * Check if a given object implements the PropertyTypeItemDto interface.
 */
function instanceOfPropertyTypeItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('propertyClass' in value) || value['propertyClass'] === undefined)
        return false;
    return true;
}
function PropertyTypeItemDtoFromJSON(json) {
    return PropertyTypeItemDtoFromJSONTyped(json, false);
}
function PropertyTypeItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'propertyClass': (0, PropertyClassDto_1.PropertyClassDtoFromJSON)(json['propertyClass']),
    };
}
function PropertyTypeItemDtoToJSON(json) {
    return PropertyTypeItemDtoToJSONTyped(json, false);
}
function PropertyTypeItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'propertyClass': (0, PropertyClassDto_1.PropertyClassDtoToJSON)(value['propertyClass']),
    };
}
